<template>
    <form @submit.prevent="reset" class="login-form">
        <div class="form-group">
            <label  for="email">{{ $t('Email') }}</label>
            <input
                id="email"
                v-model="user.email"
                :placeholder="$t('Email')"
                class="form-control"
                required
                type="text"
            />
        </div>
        <div class="form-group">
            <label  for="password">{{ $t('Password') }}</label>
            <input
                id="password"
                v-model="user.password"
                class="form-control"
                placeholder="******************"
                required
                type="password"
            />
        </div>
        <div class="form-group">
            <label for="password_confirmation">{{ $t('Confirm password') }}</label>
            <input
                id="password_confirmation"
                v-model="user.password_confirmation"
                class="form-control"
                placeholder="******************"
                required
                type="password"
            />
        </div>
        <div class=" form-group text-center mt-4 mb-3">
            <button id="submit-reset" class="btn btn-button d-inline-block" type="submit">
               Reset Password
            </button>
        </div>
        <p class="text-center">
            {{ $t('Do you already have access to your account?') }}
            <router-link  to="/auth/login"  >  {{ $t('Sign In') }} </router-link>
        </p>
    </form>
</template>

<script>
export default {
    name: "reset",
   
    data() {
        return {
            user: {
                token: null,
                email: null,
                password: null,
                password_confirmation: null
            }
        }
    },
    mounted() {
        this.user.token = this.$route.params.token;
    },
    methods: {
        reset() {
            let self = this;
            let ladda = Ladda.create(document.querySelector('#submit-reset'));
            ladda.start();
            axios.post('api/auth/reset', this.user).then(function (response) {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Password changed successfully').toString(),
                    type: 'success'
                })
                self.$store.commit('login', response.data);
                self.$router.push('/dashboard/home');
            }).catch(function () {
                self.user.password = null;
                self.user.password_confirmation = null;
            });
        }
    }
}
</script>
